// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BalanceAPIModel,
    BalanceAPIModelFromJSON,
    BalanceAPIModelFromJSONTyped,
    BalanceAPIModelToJSON,
} from './';

/**
 * 
 * @export
 * @interface FiatAccountAPIModel
 */
export interface FiatAccountAPIModel {
    /**
     * 
     * @type {number}
     * @memberof FiatAccountAPIModel
     */
    id: number;
    /**
     * 
     * @type {BalanceAPIModel}
     * @memberof FiatAccountAPIModel
     */
    balance: BalanceAPIModel;
}

export function FiatAccountAPIModelFromJSON(json: any): FiatAccountAPIModel {
    return FiatAccountAPIModelFromJSONTyped(json, false);
}

export function FiatAccountAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FiatAccountAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'balance': BalanceAPIModelFromJSON(json['balance']),
    };
}

export function FiatAccountAPIModelToJSON(value?: FiatAccountAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'balance': BalanceAPIModelToJSON(value.balance),
    };
}


